import EmptyCartWave from './empty-cart-wave'

export default EmptyCartWave
